<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    title?: string
    items?: {
      title: string
      description: string
      icon?: string
    }[]
  }>(),
  {
    title: 'Keuntungan Menggunakan Plugin WooCommerce KiriminAja',
    items: () => [
      {
        title: 'Tarif Ongkos Kirim Otomatis',
        description:
          'Tampil langsung di Cart & Checkout WooCommerce tanpa input manual.',
        icon: 'material-symbols:shopping-bag-outline'
      },
      {
        title: 'Cek Resi Plugin Real-Time',
        description: 'Pelanggan bisa melacak paket langsung di website toko.',
        icon: 'material-symbols:bolt-outline'
      },
      {
        title: 'Gratis Tanpa Biaya Bulanan',
        description:
          'Plugin ongkir KiriminAja disediakan tanpa biaya berlangganan tambahan.',
        icon: 'material-symbols:thumb-up-outline'
      },
      {
        title: 'Integrasi Mudah, Tanpa Coding',
        description: 'Cukup hubungkan API Key KiriminAja, plugin siap dipakai.',
        icon: 'material-symbols:integration-instructions-outline'
      },
      {
        title: 'Multi Ekspedisi',
        description:
          'Kirim dari berbagai ekspedisi yang tersedia di Dashboard KiriminAja',
        icon: 'material-symbols:package-2-outline'
      }
    ]
  }
)

const chunked = computed(() => {
  // chunk props.items to max 3 items per array
  const chunkSize = 3
  const chunks = []
  for (let i = 0; i < (props.items?.length ?? 0); i += chunkSize) {
    chunks.push(props.items?.slice(i, i + chunkSize))
  }
  return chunks
})
</script>

<template>
  <section class="bg-surface-container-low dark:bg-surface-container-highest">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <UiSectionTitle class="text-center" :title="title" />

      <div class="space-y-6">
        <div
          class="grid lg:inline-grid lg:mx-auto grid-cols-1 gap-6 justify-center lg:grid-cols-3"
        >
          <UiCardFeature
            v-for="(item, key) in chunked[0]"
            :key="key"
            :icon="item.icon"
            icon-size="33px"
            :title="item.title"
            :description="item.description"
          />
        </div>
        <div
          class="grid lg:inline-grid lg:px-32 lg:mx-auto grid-cols-1 gap-6 justify-center lg:grid-cols-2"
        >
          <UiCardFeature
            v-for="(item, key) in chunked[1]"
            :key="key"
            :icon="item.icon"
            icon-size="33px"
            :title="item.title"
            :description="item.description"
          />
        </div>
      </div>
    </UiContainer>
  </section>
</template>
